module.exports = __webpack_public_path__ + "static/media/logo-mosterdzaadje.2dcfa25d.jpeg";